import React from 'react'
import { Typography, Icon, Row, Col, Spin } from 'antd'
import { Queries  } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgcontact from '../../../assets/images/contact.jpg'
const { Text, Title } = Typography

class LayoutsNoData extends React.Component {

    render() {
        const { match } = this.props
        return (
            <Container match={match}>
            </Container>
        )
    }
}

LayoutsNoData.propTypes = {
    //
}

export default withApollo(LayoutsNoData)